import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';
import { TypedFormGroup, TypedFormControl } from '@principle-theorem/ng-shared';
import {
  IAccJawAlveolusTmj,
  AccAlveolusInjury,
  AccToothNumber,
  AccJawInjury,
  AccTmjInjury,
} from '@principle-theorem/principle-core/interfaces';
import { filterUndefined } from '@principle-theorem/shared';
import { hasRequiredError, setRequiredValidation } from './form-group-helpers';

export class AccJawAlveolusTmjFormGroup extends TypedFormGroup<IAccJawAlveolusTmj> {
  constructor() {
    super({
      alveolusInjuries: new TypedFormControl<AccAlveolusInjury[]>([]),
      teethInvolved: new TypedFormControl<AccToothNumber[]>([]),
      jawInjuries: new TypedFormControl<AccJawInjury[]>([]),
      typePosition: new TypedFormControl<string>(
        undefined,
        Validators.maxLength(100)
      ),
      tmjInjuries: new TypedFormControl<AccTmjInjury[]>([]),
      specificInjury: new TypedFormControl<string>(
        undefined,
        Validators.maxLength(100)
      ),
    });

    this._setupValidationHandlers();
  }

  get teethInvolvedRequiredError(): boolean {
    return hasRequiredError(this.controls.teethInvolved);
  }

  get typePositionRequiredError(): boolean {
    return hasRequiredError(this.controls.typePosition);
  }

  get specificInjuryRequiredError(): boolean {
    return hasRequiredError(this.controls.specificInjury);
  }

  private _setupValidationHandlers(): void {
    // teethInvolved is required when alveolusInjuries has a value
    this.controls.alveolusInjuries.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) =>
        setRequiredValidation(value.length > 0, this.controls.teethInvolved, [])
      );

    // typePosition is required when jawInjuries has a value
    this.controls.jawInjuries.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) =>
        setRequiredValidation(
          value.length > 0,
          this.controls.typePosition,
          undefined,
          [Validators.maxLength(100)]
        )
      );

    // specificInjury is required when tmjInjuries has a value
    this.controls.tmjInjuries.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) =>
        setRequiredValidation(
          value.length > 0,
          this.controls.specificInjury,
          undefined,
          [Validators.maxLength(100)]
        )
      );
  }
}
